import React from "react";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { resolveErrorMessage } from "../../utils/resolveErrorMessage";
import { DeleteServiceReminder } from "../../graphql/mutations/deleteServiceReminder";
import ConfirmDeleteModal from "../ConfirmDeleteModal";

interface Props {
    open: boolean;
    reminderId: string;
    serviceName?: string;
    onClose: () => void;
}

const DeleteServiceReminderModal = ({ open, reminderId, serviceName, onClose }: Props) => {
    const { t } = useTranslation();

    const [deleteServiceReminder, { loading }] = useMutation(DeleteServiceReminder, {
        refetchQueries: ["ServiceReminderList"],
    });

    const handleConfirm = () => {
        deleteServiceReminder({ variables: { id: reminderId } })
            .then((res) => {
                const success = res.data?.deleteServiceReminder?.success;
                const message = res.data?.deleteServiceReminder?.message;
                if (success) {
                    toast.success(message || t("Service reminder deleted successfully."));
                    onClose();
                } else {
                    toast.error(message || t("Error deleting service reminder."));
                }
            })
            .catch((err) => {
                toast.error(resolveErrorMessage(err, t));
            });
    };

    return (
        <ConfirmDeleteModal
            open={open}
            loading={loading}
            onConfirm={handleConfirm}
            onClose={onClose}
            title={t("Delete service reminder")}
            message={
                serviceName
                    ? t(
                          "Are you sure you want to permanently delete the service reminder {{name}}? This action cannot be undone.",
                          { name: serviceName }
                      )
                    : t("Are you sure you want to permanently delete this service reminder? This action cannot be undone.")
            }
        />
    );
};

export default DeleteServiceReminderModal;
